export enum TaskStatus {
	Not_Started = 'Not Started',
	In_Progress = 'In Progress',
    Done = 'Done'
}